import i18next from 'i18next';
import React from 'react';
import styled from 'styled-components';

import { isEmpty } from 'lodash';
import InputEmailChip from '@lib/inpulse/InputEmailChip';

// Send Transfer List Modal styled components
const Container = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: 24px;
  align-items: center;
`;

const EmailContainer = styled.div`
  width: 420px;
  min-height: 40px;
`;

export const getSendTransferListModalConfig = ({
  transferList,
  emailsTo,
  emailsCC,
  setEmailsTo,
  setEmailsCC,
  handleTransferListSend,
}) => ({
  type: 'action',
  width: '560px',
  height: 'auto',
  icon: '/images/inpulse/send-black-small.svg',
  title: i18next.t('STOCKS.TRANSFERS.SEND_TRANSFER_BY_EMAIL'),
  component: () => (
    <Container>
      <EmailContainer>
        <InputEmailChip
          emails={emailsTo}
          placeholder={i18next.t('ORDERS.ORDERS.CART_RECIPIENTS')}
          setEmails={(value) => {
            setEmailsTo(value.length ? value.split(',') : []);
          }}
          title={i18next.t('ORDERS.ORDERS.CART_RECIPIENTS')}
          width={'100%'}
          required
        />
      </EmailContainer>
      <EmailContainer>
        <InputEmailChip
          emails={emailsCC}
          placeholder={i18next.t('ORDERS.ORDERS.CART_RECIPIENTS_COPIES')}
          setEmails={(value) => {
            setEmailsCC(value.length ? value.split(',') : []);
          }}
          title={i18next.t('ORDERS.ORDERS.CART_RECIPIENTS_COPIES')}
          width={'100%'}
        />
      </EmailContainer>
    </Container>
  ),
  actions: [
    {
      key: 0,
      color: 'inpulse-outline',
      label: i18next.t('GENERAL.VALIDATE_WITHOUT_SENDING'),
      icon: '/images/inpulse/save-black-small.svg',
      handleClick: () => handleTransferListSend([], [], transferList),
    },
    {
      key: 1,
      color: 'inpulse-default',
      label: i18next.t('GENERAL.SEND'),
      icon: '/images/inpulse/send-white-small.svg',
      isDisabled: isEmpty(emailsTo),
      handleClick: () => handleTransferListSend(emailsTo, emailsCC, transferList),
    },
  ],
});
